module.exports = __webpack_public_path__ + "img/local-activities.6538f8f7.jpeg";